import {
  ChartLineUpIcon,
  ClockCounterClockwiseIcon,
  EnvelopeSimpleIcon,
  FileTextIcon,
  GlobeHemisphereWestIcon,
  HouseLineIcon,
  ImageSquareIcon,
  SignOutIcon,
  SlidersHorizontalIcon,
  UsersThreeIcon,
} from "@phosphor-icons/react";
import type { ReactNode } from "react";

import { useAuth } from "../auth/AuthProvider";
import { NavLink } from "../router";

const navigation: Array<{
  to: string;
  label: string;
  icon: typeof HouseLineIcon;
  disabled?: boolean;
}> = [
  { to: "/", label: "Обзор", icon: HouseLineIcon },
  { to: "/pages", label: "Страницы", icon: FileTextIcon },
  { to: "/locales", label: "Языки", icon: GlobeHemisphereWestIcon },
  { to: "/media", label: "Медиатека", icon: ImageSquareIcon },
  { to: "/settings", label: "Настройки", icon: SlidersHorizontalIcon },
  { to: "/team", label: "Команда", icon: UsersThreeIcon },
  { to: "/analytics", label: "Аналитика", icon: ChartLineUpIcon },
  { to: "/leads", label: "Заявки", icon: EnvelopeSimpleIcon },
  { to: "/activity", label: "Журнал", icon: ClockCounterClockwiseIcon },
];

export function AppShell({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <span className="brand__mark">U</span>
          <div>
            <strong>Unicore</strong>
            <span>Command Center</span>
          </div>
        </div>

        <nav className="sidebar__nav" aria-label="Главная навигация">
          {navigation.map(({ to, label, icon: Icon, disabled }) =>
            disabled ? (
              <span className="nav-item nav-item--disabled" key={to}>
                <Icon size={19} weight="regular" />
                {label}
                <span className="nav-item__soon">позже</span>
              </span>
            ) : (
              <NavLink
                className={({ isActive }) =>
                  `nav-item ${isActive ? "nav-item--active" : ""}`
                }
                end={to === "/"}
                key={to}
                to={to}
              >
                <Icon size={19} weight="regular" />
                {label}
              </NavLink>
            ),
          )}
        </nav>

        <div className="sidebar__account">
          <span className="account-avatar">
            {user?.display_name.slice(0, 2).toUpperCase()}
          </span>
          <div className="account-copy">
            <strong>{user?.display_name}</strong>
            <span>@{user?.username}</span>
          </div>
          <button
            className="icon-action"
            onClick={() => void logout()}
            title="Выйти"
          >
            <SignOutIcon size={19} />
          </button>
        </div>
      </aside>

      <main className="workspace">{children}</main>
    </div>
  );
}
